import { useTranslation } from "react-i18next"
import { StatusBadgeHelp } from "@dehub/theme"
import { DotPill, Tone } from "../../delivery/atoms"

const TONES: Record<string, Tone> = {
  DRAFT: "grey",
  APPROVED: "blue",
  DISPATCHED_PICKUP: "amber",
  PICKUP_COMPLETED: "amber",
  IN_TRANSIT: "blue",
  AT_DESTINATION: "blue",
  RECEIVED: "green",
  CANCELLED: "red",
}

/** Inbound order status: coloured dot + dark text. */
export function InboundStatusBadge({ status }: Readonly<{ status: string | null | undefined }>) {
  const { t } = useTranslation("inbound")
  if (!status) return <>-</>
  const name = t(`status.${status}`, { defaultValue: "-" })
  // @dehub/help: hover popover with the status guide (R5); plain pill without content (R10).
  return (
    <StatusBadgeHelp helpNs="order.inbound-status" code={status} name={name}>
      <DotPill tone={TONES[status] ?? "grey"}>{name}</DotPill>
    </StatusBadgeHelp>
  )
}
